import { Suspense } from 'react';
import { Routes as ReactRoutes, Route, Navigate } from 'react-router-dom';
import routesConfig from './routes.config';
import RedirectToNotfound from '../pages/Notfound';
import Layout from 'layouts/Layout';
import PageLoader from 'components/PageLoader';
import { isAuthenticated } from '../utils/helpers';

// Public route wrapper
const Public = (route) => {
  const { Component } = route;
  return (
    <Suspense fallback={<PageLoader loading={true} className='!bg-white' />}>
      <Component />
    </Suspense>
  );
};

// Protected route wrapper with authentication check
const Private = (route) => {
  const { Component } = route;
  const isUserLoggedIn = isAuthenticated();
  
  return (
    <Suspense fallback={<PageLoader loading={true} className='!bg-white' />}>
      {isUserLoggedIn ? <Component /> : <Navigate to="/" replace />}
    </Suspense>
  );
};

// Standalone route wrapper - no layout, no authentication check
const Standalone = (route) => {
  const { Component } = route;
  return (
    <Suspense fallback={<PageLoader loading={true} className='!bg-white' />}>
      <Component />
    </Suspense>
  );
};

// Create nested routes with proper authentication
const createNestedRoutes = (routes, RouteType, isPrivate = false) => {
  return routes.map((route, index) => {
    if (!route.Component) {
      throw new Error('Component is not available!');
    }
    
    if (route.children) {
      return (
        <Route path={route.path} key={index} element={<RouteType {...route} />}>
          {createNestedRoutes(route.children, RouteType, isPrivate)}
        </Route>
      );
    } else {
      return (
        <Route
          key={index}
          path={route.path}
          element={<RouteType {...route} />}
        />
      );
    }
  });
};

const Routing = () => {
  const { private: privateRoutes, public: publicRoutes, standalone: standaloneRoutes } = routesConfig;

  return (
    <ReactRoutes>
      {/* Standalone routes - separate pages without layout */}
      {standaloneRoutes.map((route, index) => (
        <Route
          key={`standalone-${index}`}
          path={route.path}
          element={<Standalone {...route} />}
        />
      ))}
      
      <Route path='/' element={<Layout />}>
        {/* Public routes - always accessible */}
        {createNestedRoutes(publicRoutes, Public, false)}

        {/* Private routes - auth check handled inside Private wrapper */}
        {createNestedRoutes(privateRoutes, Private, true)}
      </Route>
      
      {/* Catch all route - redirect to home */}
      <Route path='*' element={<RedirectToNotfound />} />
    </ReactRoutes>
  );
};

export default Routing;
